module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAA7klEQVRIS+3WvRGCQBAF4LcBGFqDJRkIY4SbiGSWACUYqRGkElECJVCCdkADsg6Mg7/IgQzREcLMfbt7DzjCyBeN7EEZ3IfxiggOEaWuswj6FqoMHqNYnpCMBLxmK+sK9wVLJxeCv3GsXRf0H/DuSGKKyczzXAUeAKyYHCLssp20oUOBFWqKMWvrdEgQhVxnHi/Pv7rsBwouAN4WltRl2x9spIcolro6kUBl8W94zw412LyTeqT1bF4+3jqlP95+HRodmrafw8dzHZpHaMI4B2Fa3igE7LEVdZ4noH4QPoYnH6CtAOkExqrt7NJUzA1eZbkdjRV2mQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/images/course/editSourceIcon/up.png
// module id = +Mzb
// module chunks = 96